import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {LovValueUpdateModule} from "../lov-value-update/lov-value-update.module";
import {LovValueUpdateModalComponent} from "./lov-value-update-modal.component";
import {ModalModule} from "../../../../../../../components/common/modal/modal.module";
import {DialogModule} from '../../../../../dialog/dialog.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ModalModule,
        LovValueUpdateModule,
        DialogModule,
    ],
    declarations: [
        LovValueUpdateModalComponent
    ],
    exports: [
        LovValueUpdateModalComponent,
    ]
})
export class LovValueUpdateModalModule {
}
